let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hHVmX")).then(() => parcelRequire('cB8Zf'));